"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateAccessibilityScore = void 0;
// Weights are stored pre-multiplied by 100 so the reduce is exact: integer
// addition like 0 + 40 + 80 + 100 has no floating-point error, whereas
// 0 + 0.4 + 0.8 + 1.0 does. The final division by scan count is the only
// float step, and produces the percentage directly.
const SEVERITY_PERCENT = {
    critical: 0,
    serious: 40,
    moderate: 80,
    minor: 100
};
const CLEAN_PERCENT = 100;
const SEVERITY_PRIORITY = {
    critical: 4,
    serious: 3,
    moderate: 2,
    minor: 1
};
const worstSeverity = (impacts) => {
    let worst = null;
    for (const impact of impacts) {
        if (!impact)
            continue;
        if (worst === null ||
            SEVERITY_PRIORITY[impact] > SEVERITY_PRIORITY[worst]) {
            worst = impact;
            if (worst === 'critical')
                return worst;
        }
    }
    return worst;
};
/**
 * Compute the authoritative accessibility score for a session of scans.
 *
 * Each entry in `scans` is one scan represented as the impacts of its
 * violations (e.g. `axeResult.findings.violations.map(v => v.impact)` for
 * Reporter CLI consumers, `pageStateResult.result.map(r => r.impact)` for
 * jazzband consumers). Per scan: Critical → 0, Serious → 40, Moderate → 80,
 * Minor or no impactful violations → 100. The result is the average across
 * all scans, in [0, 100]. Returns `null` for the zero-scan case to
 * distinguish "not scored" from any numeric value.
 *
 * The result is not rounded — consumers format on display.
 *
 * @param scans - One impact-list per scan
 * @returns Score in [0, 100], or `null` when there are no scans
 */
const calculateAccessibilityScore = (scans) => {
    if (scans.length === 0) {
        return null;
    }
    const sum = scans.reduce((acc, impacts) => {
        const worst = worstSeverity(impacts);
        return acc + (worst === null ? CLEAN_PERCENT : SEVERITY_PERCENT[worst]);
    }, 0);
    return sum / scans.length;
};
exports.calculateAccessibilityScore = calculateAccessibilityScore;
//# sourceMappingURL=accessibilityScore.js.map